export default function getTextWidthLimit(windowWidth) {
  if (windowWidth > 360) {
    return 260;
  }
  if (windowWidth > 320 && windowWidth <= 360) {
    return 240;
  }
  return 220;
}
